import { useState, useCallback } from 'react';
import { graphQlClient } from '@config/graphqlClient';
import EquipmentGraphQL from '@graphql/equipment.queries';

interface UseDeleteEquipmentReturn {
  deleteEquipment: (id: string) => Promise<boolean>;
  loading: boolean;
  error: string | null;
}

export const useDeleteEquipment = (): UseDeleteEquipmentReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteEquipment = useCallback(async (id: string): Promise<boolean> => {
    if (!id) return false;

    setLoading(true);
    setError(null);

    try {
      const data: any = await graphQlClient.request(
        EquipmentGraphQL.mutations.deleteEquipment,
        { id },
      );

      const success = data?.deleteEquipment?.affected > 0;
      if (!success) {
        setError('Failed to delete equipment');
        return false;
      }

      return true;
    } catch (err: any) {
      setError(
        err?.response?.errors?.[0]?.message || 'Failed to delete equipment',
      );
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    deleteEquipment,
    loading,
    error,
  };
};
